function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M22 15.5v-2.3c0-1.12 0-1.68-.218-2.108a2 2 0 00-.874-.874C20.48 10 19.92 10 18.8 10h-6.6c-1.12 0-1.68 0-2.108.218a2 2 0 00-.874.874C9 11.52 9 12.08 9 13.2v3.743c0 1.12 0 1.68.218 2.108a2 2 0 00.874.874c.428.218.988.218 2.108.218h5.294c.967 0 1.897.372 2.597 1.039.72.685 1.909.175 1.909-.818V19M9 14H7.25c-.247 0-.37 0-.491.01-.483.039-.95.194-1.36.453-.102.065-.201.139-.399.287-.511.384-.767.575-.962.65a1.5 1.5 0 01-1.98-.99C2 14.209 2 13.89 2 13.25V6.8c0-1.68 0-2.52.327-3.162a3 3 0 011.311-1.311C4.28 2 5.12 2 6.8 2h6.4c1.68 0 2.52 0 3.162.327a3 3 0 011.311 1.311C18 4.28 18 5.12 18 6.8v.7",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgComments = function SvgComments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#2F384C"
  }, props), _ref);
};

export default SvgComments;